import { render } from "./CustomerCad.vue?vue&type=template&id=481d6066&scoped=true"
import script from "./CustomerCad.vue?vue&type=script&lang=js"
export * from "./CustomerCad.vue?vue&type=script&lang=js"

import "./CustomerCad.vue?vue&type=style&index=0&id=481d6066&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481d6066"]])

export default __exports__